import React from 'react';
import ChangeRoomServiceNumberModal from "../../../../Modal/ChangeRoomServiceNumberModal";
import {RootState} from "../../../../../../reducers";
import {getSession} from "../../../../../services/Session/reducer";
import {getCart} from "../../../../../services/Cart/reducer";
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {OrderType} from "../../../../../services/Api/types";
import {ReactComponent as RoomServiceSVG} from "../../../../../../images/icons/room-service.svg";
import {getStoreConfig} from "../../../../../services/Store/reducer";

interface OwnProps {
    loading: boolean;
    orderType: OrderType;
    roomNumberModal: boolean;
    setRoomNumberModal: React.Dispatch<React.SetStateAction<boolean>>;
    handleChangeType: (
        event: any,
        value?: string,
    ) => Promise<void>;
    handleOnTypeLabelKeyDown: (
        orderType: string,
    ) => (event: (React.KeyboardEvent<HTMLLabelElement> | KeyboardEvent)) => Promise<void>;
    drawOpenHours: (
        orderType: OrderType,
    ) => JSX.Element;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const CartPageRoomServiceOption = ({
                                       handleOnTypeLabelKeyDown,
                                       cart,
                                       loading,
                                       orderType,
                                       handleChangeType,
                                       session,
                                       roomNumberModal,
                                       setRoomNumberModal,
                                       config,
                                       drawOpenHours
                                   }: Props) => {
    const {t} = useTranslation();
    const roomNumber = session.room_number;
    const checked = orderType === OrderType.ROOM_SERVICE;

    if (config?.ordering.room_service || orderType === OrderType.ROOM_SERVICE) {
        return (
            <label onKeyDown={handleOnTypeLabelKeyDown("ROOM_SERVICE")} tabIndex={0} aria-checked={checked}
                   className={`btn btn-default btn-lg btn-check-full btn-spinner${(cart.pending || loading) ? " loading" : ""}${orderType === OrderType.ROOM_SERVICE ? " active" : ""}`}>
                <RoomServiceSVG/>
                <span>
                    <p className="mb-0">{t("enums.order.type.ROOM_SERVICE")}</p>
                    {drawOpenHours(OrderType.ROOM_SERVICE)}
                </span>
                <input className="btn-check1" type="radio" name="type" value="ROOM_SERVICE" autoComplete="off"
                       tabIndex={-1}
                       checked={checked}
                       onChange={handleChangeType}/>
                <div className="spinner-border spinner-border-sm"></div>
                <ChangeRoomServiceNumberModal roomNumber={roomNumber} show={roomNumberModal}
                                              onSave={() => setRoomNumberModal(false)}
                                              onHide={() => setRoomNumberModal(false)}/>
            </label>
        )
    }

    return <></>;
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
    cart: getCart(state.cart),
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartPageRoomServiceOption));
